import { escapeString, generateIcon, pictureGenerate, printMoney } from "@process-creative/slate-theme-tools";
import { ON_VARIANT_CHANGE } from '../../objects/variant/VariantSelector';
import * as ResponsiveSizes from './../../settings/Responsive';

const ATTR_INSERT = `data-pillow-insert`
const ATTR_CHECKBOX = `${ATTR_INSERT}-checkbox`

//Selectors
const SEL_CONTAINER = `[${ATTR_INSERT}]`;
const SEL_DATA = `[${ATTR_INSERT}-data]`;
const SEL_CAROUSEL = `[${ATTR_INSERT}-carousel]`;
const SEL_TITLE = `[${ATTR_INSERT}-title]`;
const SEL_CHECKBOX = `[${ATTR_CHECKBOX}]`;

const CLS_OPEN = 'is-open';

export const PillowInsertUpsell = ({ template }) => {
  //"state"
  const state = {};//KVP where K = variant id, V = boolean
  const listeners = [];

  //jQuery to Vanilla
  let templConts = [];
  const templCont = template;
  for(let i = 0; i < templCont.length; i++) templConts.push(templCont[i]);

  const render = () => {
    templConts.forEach(tCont => {
      //Traditional
      tCont.querySelectorAll(SEL_CONTAINER).forEach(container => {
        //Find elements
        const [
          containerData, containerCarousel, title
        ] = [
          SEL_DATA, SEL_CAROUSEL, SEL_TITLE
        ].map(s => container.querySelector(s));
        if(!containerData || !containerCarousel) {
          container.classList.remove(CLS_OPEN);
          return;
        };

        //Load Data
        let data;
        try {
          data = JSON.parse(containerData.innerHTML);
        } catch(e) {
          container.classList.remove(CLS_OPEN);
          console.error(e);
          return;
        }

        //Clear crap
        if(containerCarousel) containerCarousel.innerHTML = '';
      
        //Get the current size
        let currentSize = null;
        const sizeElement = document.querySelector('[data-swatch-option-name="Size"]');
        if(sizeElement) currentSize = sizeElement.value;
        
        //Print items
        let printedCount = 0;
        data.products.some((product,i) => {
          const variant = product.variants.find(v => v.available);
          if(!variant) return;

          if(currentSize) {
            const optionIndex = product.options.findIndex(op => (
              op.toLowerCase() == 'size'
            ));

            if(optionIndex !== -1 && variant.options[optionIndex] !== currentSize) {
              return;
            }
          }
            
          let img = variant.image || variant.featured_image || product.featured_image || product.image;
          img = img.src || img;
  
          let name;
          const matchTag = product.tags.some(t => {
            const [ prefix, ...suffix ] = t.split('_');
            if(!prefix || !suffix || !prefix.toLowerCase() == 'insert') return false;
            name = suffix.join('_');
            return true;
          });
  
          if(!name) name = product.title;
          const element = document.createElement('div');
          element.classList.add('c-pillow-insert__item')
          element.setAttribute('data-insert', true);
          element.innerHTML = `
            <input type="checkbox" ${ATTR_CHECKBOX} name="${ATTR_CHECKBOX}"
              value="${product.id}" class="c-pillow-insert__item-checkbox"
            />
            
  
            <div class="c-pillow-insert__item-outline"></div>
  
            <div class="c-pillow-insert__item-picture">
              ${pictureGenerate({
                src: img, srcSize: 600, alt: product.title,
                class: 'c-pillow-insert__item-picture-image'
              })}
            </div>
  
            <p class="c-pillow-insert__item-content">
              <label class="c-pillow-insert__item-title">
                ${escapeString(name)}
              </label>
              <span data-currency data-money="${variant.price}">
                ${printMoney(variant.price)}
              </span>
            </p>

            <div class="c-pillow-insert__item-box is-not-checked">
              ${generateIcon('plus-white', 'c-pillow-insert__item-box-icon')}
            </div>

            <div class="c-pillow-insert__item-box is-checked">
              ${generateIcon('minus-white', 'c-pillow-insert__item-box-icon')}
            </div>
          `;
  
          const checkbox = element.querySelector(SEL_CHECKBOX);
          checkbox.addEventListener('change', e => {
            state[variant.id] = checkbox.checked;
            listeners.forEach(l => l(state));
          });
  
          containerCarousel.appendChild(element);
  
          printedCount++;
          if(printedCount >= 4) return true;
        });


        if ($(window).width() >= ResponsiveSizes.small) return;
        
        if(!$(containerCarousel).hasClass('slick-initialized')) {
          $(containerCarousel).slick({
            slidesToScroll: 1,
            slidesToShow: 1.5,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            responsive: [
              {
                breakpoint: ResponsiveSizes.xsmall-1,
                settings: { slidesToShow: 1.5 }
              },
              {
                breakpoint: ResponsiveSizes.medium-1,
                settings: { slidesToShow: 4 }
              },
              {
                breakpoint: ResponsiveSizes.large-1,
                settings: { slidesToShow: 4 }
              },
              {
                breakpoint: ResponsiveSizes.xlarge-1,
                settings: { slidesToShow: 4 }
              }
            ]
          });
        }


        $(containerCarousel).on('beforeChange', (e, slick, currentSlide, nextSlide) => {
          let calc = ((nextSlide) / (slick.slideCount)) * 100;
          calc = (calc + (100 / slick.slideCount));
          $('[data-pillow-insert-progress]').css('width', calc + '% ');
        });


      })
    });
  };

  render();
  $(document).on(ON_VARIANT_CHANGE, e => render());

  return {
    state, listeners, render
  };
}

export const pillowInsertGetState = (insert) => {
  return Object.entries(insert.state).map(e => {
    const [ id, enabled ] = e;
    if(!enabled) return null;
    return { id, quantity: 1 }
  }).filter(f => f);
};

export const pillowInsertListen = ({ insert, listener }) => (
  insert.listeners.push(listener)
);


